import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';
import replaceNull from 'utils/replace-null';

import { AppState } from 'services/types';
import { FertilizerProductId } from 'services/fertilizerEvents/types';
import { OwnProps } from './index';
import { selectFertilizerWorksheetProductsKeyedById } from '../../../../selectors';

const selectProductId = (
    state: AppState,
    props: OwnProps
): FertilizerProductId => props.productId;

const selectProductSMgCa = createDeepEqualSelector(
    selectFertilizerWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) => {
        const sulfurValue = get(
            productsKeyedById,
            [productId, 'fertilizerProduct', 'sulfurValue'],
            0
        );
        const magnesiumValue = get(
            productsKeyedById,
            [productId, 'fertilizerProduct', 'magnesiumValue'],
            0
        );
        const calciumValue = get(
            productsKeyedById,
            [productId, 'fertilizerProduct', 'calciumValue'],
            0
        );

        return `${replaceNull(sulfurValue)}:${replaceNull(
            magnesiumValue
        )}:${replaceNull(calciumValue)}`;
    }
);

const makeSelectProductSMgCa = (): typeof selectProductSMgCa =>
    selectProductSMgCa;

export { selectProductId, makeSelectProductSMgCa };
